import type { FilterModel } from "~/components/grid/AgGrid";
import type { GridRequestInput } from "~/gql/graphqlBase.generated";
import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";

import { OrderStatus } from "~/gql/graphqlBase.generated";
import { buildDeepLinkFilterModel, resolveDeepLinkFilters } from "~/helpers/aiChat/gridDeepLinkFilters";
import { buildWhere, createOrdersDatasourceTransform } from "~fulfill/orders/helpers/ordersCombinedFilter";

export const CUSTOMER_ORDERS_TARGET_KIND = "customerOrders";

const customerHealthOrders = (customerId: string, route: string, salesPerson?: string) => {
	const params = new URLSearchParams(route.split("?")[1]);
	params.delete("customerName");
	if (!params.has("status"))
		params.set(
			"status",
			Object.values(OrderStatus)
				.filter((status) => status !== OrderStatus.Deleted)
				.join(",")
		);
	params.set("customerId", customerId);
	const listFilters = Object.fromEntries(params);
	const target: ContinuationTarget = { listFilters, targetId: customerId, targetKind: CUSTOMER_ORDERS_TARGET_KIND };
	const filterModel = buildDeepLinkFilterModel(resolveDeepLinkFilters("/fulfill/orders", params));
	const request: GridRequestInput = {
		endRow: 1,
		filterModel,
		groupKeys: [],
		rowGroupCols: [],
		sortModel: [],
		startRow: 0,
		valueCols: []
	};
	const transformed = createOrdersDatasourceTransform({
		getIncludeDeleted: () => false,
		getIncludeInitialized: () => true,
		getSalesPersonScope: () => salesPerson
	})(request);
	return {
		route: `/fulfill/orders?${params}`,
		target,
		where: buildWhere(transformed.filterModel as FilterModel, undefined, undefined)
	};
};
export default customerHealthOrders;
